<template>
  <section>
    <ul class="filters-list">
      <li v-if="hasPermission('reports_tab', 'view')">
        <router-link
          :to="{
            name: 'NewReportCases',
            query: this.$route.query,
          }"
        >
          NEW REPORTS
          <span class="active-icon">
            <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
        ></router-link>
      </li>
      <li>
        <router-link
          :to="{
            name: 'AllCases',
            query: this.$route.query,
          }"
        >
          ALL
          <span class="active-icon">
            <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
        ></router-link>
      </li>
      <li>
        <router-link
          :to="{
            name: 'ActiveCases',
            query: this.$route.query,
          }"
        >
          ACTIVE
          <span class="active-icon">
            <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
        ></router-link>
      </li>
      <li v-if="hasPermission('cases', 'cases_filters_view')">
        <router-link
          :to="{
            name: 'PendingCases',
            query: this.$route.query,
          }"
        >
          PROCESSING
          <span class="active-icon">
            <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
        ></router-link>
      </li>
      <li>
        <router-link
          :to="{
            name: 'CompleteCases',
            query: this.$route.query,
          }"
        >
          FINALIZED
          <span class="active-icon">
            <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
        ></router-link>
      </li>
            <li v-if="hasPermission('cases', 'cases_filters_add_new')">
        <router-link
          :to="{
            name: 'ArchiveCase',
            query: this.$route.query,
          }"
        >
          ARCHIVED
          <span class="active-icon">
            <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
        ></router-link>
      </li>
      <li>
        <router-link
          :to="{
            name: 'RejectedCases',
            query: this.$route.query,
          }"
        >
          REJECTED
          <span class="active-icon">
            <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
        ></router-link>
      </li>
    </ul>
  </section>
</template>
<script>
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import { mapGetters } from "vuex";
export default {
  mixins: [UserPermissionsHelper],
  computed: {
    ...mapGetters("cases", ["getCriticalCounts"]),

    ...mapGetters("auth", ["getUserAllowedLabs", "getUserPrimaryLabId"]),
  },
  mounted() {
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
  },
};
</script>